export const PACKAGE_ID = "com.fitbersama.app";

export const LISTING = {
  title: "FitBersama: Latihan & Progres",
  short: "Catat latihan, check-in harian & pantau progres tubuh. 100% gratis.",
  full: `FitBersama adalah pendamping kebugaran harian yang 100% gratis, tanpa iklan dan tanpa langganan.

LATIHAN LEBIH TERARAH
• Pustaka 1.300+ gerakan lengkap dengan animasi peragaan, tips teknik, dan kesalahan umum
• Filter per otot, alat, kategori, dan tingkat (Pemula, Menengah, Mahir)
• Sesi live dengan timer istirahat, RPE, dan deteksi rekor pribadi (PR) otomatis
• Gerakan pengganti saat alat di gym sedang dipakai
• Program Pemula 4 Minggu dengan beban yang naik bertahap

PANTAU TUBUH & KEBIASAAN
• Check-in harian satu ketuk dengan mood, tidur, dan nyeri otot
• BMI, body fat, lingkar tubuh, dan foto progres sebelum/sesudah
• Catat kardio, tidur, nutrisi, dan air minum
• Grafik tren, heatmap konsistensi, dan estimasi 1RM

TETAP SEMANGAT
• 23 piala & pencapaian (Perunggu, Perak, Emas, Platinum), termasuk "Sebulan Penuh" check-in
• Ringkasan mingguan otomatis dan saran dari AI Coach
• Beranda teman, obrolan komunitas, dan pesan langsung

Datamu milikmu: ekspor kapan saja (JSON/CSV) dan hapus akun langsung dari aplikasi.

Catatan: FitBersama memberi informasi umum, bukan nasihat medis.`,
};

export const ANDROID_STEPS = [
  "Buka pwabuilder.com (lebih nyaman di laptop), tempel alamat aplikasi di atas, lalu klik Start.",
  "Pilih \"Package For Stores\" → Android → Generate Package. Isi Package ID persis seperti di atas, App name \"FitBersama\", dan pilih Signing key: Create new.",
  "Unduh file zip-nya. Simpan file .keystore beserta password-nya baik-baik — wajib untuk setiap update aplikasi.",
  "Buka file assetlinks.json di dalam zip dan kirimkan isinya ke saya. Setelah saya pasang, bilah alamat browser tidak akan muncul di aplikasi.",
  "Daftar Google Play Console (biaya $25 sekali bayar), buat aplikasi baru, lalu unggah file .aab dari zip.",
  "Isi halaman toko: judul, deskripsi, ikon 512, banner 1024×500, dan screenshot Android dari halaman ini; isi URL Kebijakan Privasi dan URL hapus akun.",
  "Di Play Console → Setup → App signing, salin SHA-256 \"App signing key certificate\" dan kirim ke saya juga agar ikut ditambahkan.",
  "Akun developer pribadi yang baru biasanya wajib menjalankan closed testing (minimal 12 penguji selama 14 hari) sebelum bisa rilis ke publik.",
];

export const IOS_STEPS = [
  "Siapkan Mac dengan Xcode dan akun Apple Developer ($99/tahun).",
  "Di pwabuilder.com pilih iOS → Generate Package, isi Bundle ID persis seperti Package ID di atas.",
  "Ekstrak zip di Mac, buka proyeknya di Xcode (ikuti README di dalam zip), pilih Team Apple-mu, lalu Product → Archive → Distribute App.",
  "Di App Store Connect isi halaman toko: ikon 1024, screenshot iPhone dari halaman ini, URL Kebijakan Privasi, dan info hapus akun.",
  "Catatan: Apple kadang menolak aplikasi berbasis web (aturan 4.2) atau meminta \"Sign in with Apple\" karena ada login Google (aturan 4.8). Login Google juga bisa tidak berfungsi di dalam aplikasi iOS — login email tetap jalan.",
];
